import React, { Fragment, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import './App.scss';
import AuthenticatedLayout from './layout/AuthenticatedLayout';
import FirebaseProtectedRoute from './layout/FirebaseProtectedRoute';
import NonAuthenticatedLayout from './layout/NonAuthenticatedLayout';
import Login from './pages/auth-pages/Login';
import i18n from './i18n/config';
import CompaniesList from './pages/companies/CompaniesList.js';
import UsersList from 'pages/users/UsersList';
import { SKIP_ENCRYPT, HAND_SHAKE_MAX_RETRY } from './config/config';
import { performHandshake } from './actions/handshake';

function App() {
  document.dir = i18n.dir();
  const security = useSelector((state) => state.security);
  const [handShakeRetryCount, setHandShakeRetryCount] = useState(0);

  // Establish the secure channel before any encrypted call is made: fetch the
  // server public key once and cache it in the security slice. Mirrors
  // midani-frontend's App handshake bootstrap.
  if (!security.serverPublicKey && !SKIP_ENCRYPT && handShakeRetryCount < HAND_SHAKE_MAX_RETRY) {
    setHandShakeRetryCount((prevCount) => prevCount + 1);
    performHandshake().catch((error) => {
      console.error('Handshake failed:', error);
    });
  }

  return (
    <Fragment>
      <Routes>
        <Route element={<NonAuthenticatedLayout />}>
          <Route path='/login' element={<Login />} />
        </Route>
        {/* <Route path='/about' element={<About />} /> */}

        <Route element={<FirebaseProtectedRoute />}>
          <Route path='/' element={<AuthenticatedLayout />}>
            <Route index element={<CompaniesList />} />
            <Route path='/companies' element={<CompaniesList />} />
            <Route path='/users' element={<UsersList />} />
            <Route path='*' element={<h1>Not Found</h1>} />
          </Route>
        </Route>
      </Routes>
    </Fragment>
  );
}

export default App;
